// export const OldGrouping = {
//   grp: [
//     {
//       fs_grp: "Non Current Assets",
//       notes_grp: [
//         {
//           notes_grp: "Property, Plant and Equipment",
//           notes_no: "3",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Freehold Land - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Freehold Land - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp: "Freehold Buildings - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Freehold Buildings - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp:
//                 "Furniture, Fittings & Equipment - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp:
//                 "Furniture, Fittings & Equipment - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp: "Plant & Machinery - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Plant & Machinery - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Capital Work-In Progress",
//           notes_no: "3",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Investment Properties",
//           notes_no: "4",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Other Intangible Assets",
//           notes_no: "5",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp:
//                 "Patents, Copyrights and other rights - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Patents, Copyrights and other rights - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp: "Computer Software - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Computer Software - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp: "Non-Compete Fees - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Non-Compete Fees - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp:
//                 "Intangible Assets Under Development - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Intangible Assets Under Development - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp:
//                 "Biological Assets other than Bearer Plants - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Biological Assets other than Bearer Plants - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Goodwill",
//           notes_no: "5",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Investments",
//           notes_no: "6(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Investment in equity instruments - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Equity Investments at FVOCI - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investment in equity instruments - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in preference shares - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in preference shares - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in preference shares - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in government securities - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in government securities - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in government securities - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in debentures and bonds - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in mutual funds - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Trade Receivables",
//           notes_no: "6(b)",
//           disclosures: true,
//           sub_grp: [
//             "Trade Receivables",
//             "Receivables from related parties",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Trade Receivables Considered Good - Secured",
//             "Trade Receivables Considered Good - Unsecured",
//             "Trade Receivables which have significant increase in credit risk",
//             "Trade Receivables - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Loans",
//           notes_no: "6(c)",
//           disclosures: true,
//           sub_grp: [
//             "Loan to Associates",
//             "Loan to Directors",
//             "Loan to Employees",
//             "Security Deposits",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Loans Considered Good - Secured",
//             "Loans Considered Good - Unsecured",
//             "Loans which have significant increase in credit risk",
//             "Loans - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Other Financial Assets",
//           notes_no: "6(e)",
//           disclosures: false,
//           sub_grp: [
//             "Derivatives - Foreign Exchange forward contracts",
//             "Derivatives - Foreign currency options",
//             "Derivatives - Interest rate swaps",
//             "Others - Indemnification Asset",
//           ],
//         },
//         {
//           notes_grp: "Deferred Tax Assets",
//           notes_no: "7",
//           disclosures: true,
//           sub_grp: [
//             {}
//             "Tax Losses",
//             "Defined benefit obligation","Provisions",
//             "Other Items - derivatives",
//             "Other Items - loss allowance on financial and contract assets",
//             "Other Items - others",
//             "Set-off of deferred tax liabilities pursuant to set-off provisions"
//            ],
//         },
//         {
//           notes_grp: "Contract assets",
//           notes_no: "6A",
//           disclosures: false,
//           sub_grp: [
//             "Contract assets related to IT consulting contracts",
//             "Loss allowance",
//           ],
//         },
//         {
//           notes_grp: "Other non-current Assets",
//           notes_no: "8",
//           disclosures: false,
//           sub_grp: [
//             "Capital Advances",
//             "Assets recognized from costs incurred to fulfil a contract",
//             "Advances other than capital advances",
//             "Advances to suppliers",
//             "VAT/GST recoverable",
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Current Assets",
//       notes_grp: [
//         {
//           notes_grp: "Financial Assets - Investments",
//           notes_no: "6(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Investments in equity instruments - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in equity instruments - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in equity instruments - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in debentures and bonds - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in mutual funds - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Trade Receivables",
//           notes_no: "6(b)",
//           disclosures: true,
//           sub_grp: [
//             "Trade Receivables",
//             "Receivables from related parties",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Trade Receivables Considered Good - Secured",
//             "Trade Receivables Considered Good - Unsecured",
//             "Trade Receivables which have significant increase in credit risk",
//             "Trade Receivables - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Cash and cash equivalents",
//           notes_no: "6(d)",
//           disclosures: false,
//           sub_grp: [
//             "Balances with banks in current accounts",
//             "Balances with banks in EEFC accounts",
//             "Deposits with maturity of less than 3 months",
//             "Cash on hand",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Other Financial Assets",
//           notes_no: "6(e)",
//           disclosures: false,
//           sub_grp: [
//             "Derivatives - Foreign Exchange forward contracts",
//             "Derivatives - Foreign currency options",
//             "Derivatives - Interest rate swaps",
//             "Others - Indemnification Asset",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Loans",
//           notes_no: "6(c)",
//           disclosures: true,
//           sub_grp: [
//             "Loan to Associates",
//             "Loan to Directors",
//             "Loan to Employees",
//             "Security Deposits",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Loans Considered Good - Secured",
//             "Loans Considered Good - Unsecured",
//             "Loans which have significant increase in credit risk",
//             "Loans - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Contract assets",
//           notes_no: "6A",
//           disclosures: false,
//           sub_grp: [
//             "Contract assets related to IT consulting contracts",
//             "Loss allowance",
//           ],
//         },
//         {
//           notes_grp: "Other current assets",
//           notes_no: "10",
//           disclosures: false,
//           sub_grp: ["Prepayments", "Right to recover returned goods"],
//         },
//         {
//           notes_grp: "Assets classified as held for sale",
//           notes_no: "11",
//           disclosures: false,
//           sub_grp: ["Building", "Disposal Group"],
//         },
//       ],
//     },
//     {
//       fs_grp: "Shareholder Funds",
//       notes_grp: [
//         {
//           notes_grp: "Equity Share Capital",
//           notes_no: "12(a)",
//           disclosures: false,
//           sub_grp: [],
//         },
//         {
//           notes_grp:
//             "other equity - equity component of compound financial instruments",
//           notes_no: "13(a)",
//           disclosures: false,
//           sub_grp: [],
//         },
//         {
//           notes_grp: "other equity - reserves and surplus",
//           notes_no: "12(b)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Securities premium",
//               disclosures: [
//                 "Opening balance",
//                 "Exercise of options - proceeds received",
//                 "Acquisition of subsidiary",
//                 "Rights issue",
//                 "Transaction costs arising on share issues",
//               ],
//             },
//             {
//               sub_grp: "Debenture redemption reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Appropriations during the year",
//               ],
//             },
//             {
//               sub_grp: "Share options outstanding account",
//               disclosures: ["Opening balance", "Employee stock option expense"],
//             },
//             {
//               sub_grp: "Retained earnings",
//               disclosures: [
//                 "Opening balance",
//                 "Change in accounting policy",
//                 "Net profit for the period",
//                 "Items of other comprehensive income recognised directly in retained earnings - transfer to debenture redemption reserve",
//                 "Items of other comprehensive income recognised directly in retained earnings - Transactions with NCI",
//                 "Items of other comprehensive income recognised directly in retained earnings - Transfer to retained earnings of FVOCI equity investments",
//                 "Items of other comprehensive income recognised directly in retained earnings - Share of OCI of associates & joint ventures",
//                 "Items of other comprehensive income recognised directly in retained earnings - Remeasurements of post-employment benefit obligation",
//                 "Dividends",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "other equity - other reserves",
//           notes_no: "12(c)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "FVOCI equity investments",
//               disclosures: [
//                 "Opening balance",
//                 "Change in fair value of FVOCI equity investments",
//                 "Deferred tax",
//                 "Transfer of gain on FVOCI equity investments",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Cash flow hedging reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
//                 "Deferred tax",
//                 "Change in fair value of hedging instruments",
//                 "Deferred tax",
//                 "Reclassification to profit / loss",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Costs of hedging reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
//                 "Deferred tax",
//                 "Change in fair value of hedging instruments",
//                 "Deferred tax",
//                 "Reclassification to profit / loss",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Foreign currency translation reserve",
//               disclosures: [
//                 "Currency translation adjustments relating to associates",
//                 "Deferred tax",
//                 "Other currency translation differences",
//                 "Non controlling interest share in translation differences",
//                 "Net investment hedge",
//                 "Reclassification to profit / loss on disposal of discontinued operation",
//               ],
//             },
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Non Current Liabilities",
//       notes_grp: [
//         {
//           notes_grp: "Financial Liabilities - Borrowings",
//           notes_no: "13(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Secured debentures",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Secured term loans from banks",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp:
//                 "Secured long term maturities of finance lease obligations",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Unsecured term loans",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Unsecured bonds",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp:
//                 "Unsecured liability component of compound financial instruments",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//           ],
//           disclosures: [
//             "Less: Current maturities of long term debt",
//             "Less: Current maturities of finance lease obligations",
//             "Less: Interest accrued",
//           ],
//         },
//         {
//           notes_grp: "Financial liabilities - Other Financial Liabilities",
//           notes_no: "13(b)",
//           disclosures: true,
//           sub_grp: [
//             "derivatives not designated as hedges - principal swap",
//             "Others - contingent consideration",
//           ],
//         },
//         {
//           notes_grp: "Provisions",
//           notes_no: "14",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Service warranties",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp: "Legal claim",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp: "Restructuring costs",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp:
//                 "Contingent liability recognized on business combination",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Employee benefit obligations",
//           notes_no: "15",
//           disclosures: false,
//           sub_grp: [
//             "Leave obligations",
//             "Gratuity",
//             "Post employment medical benefits",
//             "Defined pension benefits",
//             "Share-appreciation rights",
//           ],
//         },
//         {
//           notes_grp: "Deferred tax liabilities",
//           notes_no: "16",
//           disclosures: true,
//           sub_grp: "[given in pdf]",
//         },
//         {
//           notes_grp: "Government grants",
//           notes_no: "18",
//           disclosures: true,
//           disclosures: [
//             "Opening balance",
//             "Grants during the year",
//             "Less: released to profit or loss",
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Current Liabilities",
//       notes_grp: [],
//     },
//   ],
// };


// export const groupingss = {
//   grp: [
//     {
//       fs_grp: "Non Current Assets",
//       notes_grp: [
//         {
//           notes_grp: "Property, Plant and Equipment",
//           notes_no: "3",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Freehold Land - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Freehold Land - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp: "Freehold Buildings - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Freehold Buildings - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp:
//                 "Furniture, Fittings & Equipment - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp:
//                 "Furniture, Fittings & Equipment - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },

//             {
//               sub_grp: "Plant & Machinery - Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Plant & Machinery - Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Capital Work-In Progress",
//           notes_no: "3",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: [
//                 "Opening Gross Carrying Amount",
//                 "Exchange Differences",
//                 "Additions",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//               ],
//             },
//             {
//               sub_grp: "Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge During The Year",
//                 "Exchange Differences",
//                 "Assets included in a disposal group classified as held for sale",
//                 "Disposals",
//                 "Impairment Loss (iii)",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Investment Properties",
//           notes_no: "4",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Closing Accumulated Depreciation",
//               disclosures: [
//                 "Opening Accumulated Depreciation",
//                 "Depreciation Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Other Intangible Assets",
//           notes_no: "5",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp:
//                 "Patents, Copyrights and other rights - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Patents, Copyrights and other rights - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp: "Computer Software - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Computer Software - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp: "Non-Compete Fees - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Non-Compete Fees - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp:
//                 "Intangible Assets Under Development - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Intangible Assets Under Development - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },

//             {
//               sub_grp:
//                 "Biological Assets other than Bearer Plants - Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp:
//                 "Biological Assets other than Bearer Plants - Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Goodwill",
//           notes_no: "5",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Closing Gross Carrying Amount",
//               disclosures: ["Opening Gross Carrying Amount", "Additions"],
//             },
//             {
//               sub_grp: "Closing Accumulated Amortization",
//               disclosures: [
//                 "Opening Accumulated Amortization",
//                 "Amortization Charge For The Year",
//                 "Impairment Charge",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Investments",
//           notes_no: "6(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Investment in equity instruments - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Equity Investments at FVOCI - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investment in equity instruments - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in preference shares - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in preference shares - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in preference shares - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in government securities - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in government securities - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in government securities - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in debentures and bonds - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in mutual funds - Unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - Quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - Impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//           ],
//         },
//         //changes below
//         {
//           notes_grp: "Financial Assets - Trade Receivables",
//           notes_no: "6(b)",
//           disclosures: true,
//           sub_grp: [
//             {sub_grp:"Trade Receivables",
//             disclosures: [
//               "Trade Receivables Considered Good - Secured",
//               "Trade Receivables Considered Good - Unsecured",
//               "Trade Receivables which have significant increase in credit risk",
//               "Trade Receivables - Credit Impaired",
//               "Loss Allowance",
//             ]},
//             {sub_grp:"Receivables from related parties",
//             disclosures: [
//               "Trade Receivables Considered Good - Secured",
//               "Trade Receivables Considered Good - Unsecured",
//               "Trade Receivables which have significant increase in credit risk",
//               "Trade Receivables - Credit Impaired",
//               "Loss Allowance",
//             ]},
//             {sub_grp:"Loss Allowance",
//             disclosures: [
//               "Trade Receivables Considered Good - Secured",
//               "Trade Receivables Considered Good - Unsecured",
//               "Trade Receivables which have significant increase in credit risk",
//               "Trade Receivables - Credit Impaired",
//               "Loss Allowance",
//             ]},
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Loans",
//           notes_no: "6(c)",
//           disclosures: true,
//           sub_grp: [
//             "Loan to Associates",
//             "Loan to Directors",
//             "Loan to Employees",
//             "Security Deposits",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Loans Considered Good - Secured",
//             "Loans Considered Good - Unsecured",
//             "Loans which have significant increase in credit risk",
//             "Loans - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Other Financial Assets",
//           notes_no: "6(e)",
//           disclosures: false,
//           sub_grp: [
//             {
//               sub_grp: "Derivatives - Foreign Exchange forward contracts",
//               disclosures: [],
//             },
//             {
//               sub_grp: "Derivatives - Foreign currency options",
//               disclosures: [],
//             },
//             { sub_grp: "Derivatives - Interest rate swaps", disclosures: [] },
//             { sub_grp: "Others - Indemnification Asset", disclosures: [] },
//           ],
//         },
//         //Changes above
//         {
//           notes_grp: "Deferred Tax Assets",
//           notes_no: "7",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Tax Losses",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp: "Defined benefit obligation",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp: "Provisions",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp: "Other Items - derivatives",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp:
//                 "Other Items - loss allowance on financial and contract assets",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp: "Other Items - others",
//               disclosures: [
//                 "Charged / credited to profit or loss",
//                 "Charged / credited to other comprehensive income",
//                 "Charged / credited to deferred tax on basis adjustment",
//                 "Acquisition of subsidiary",
//               ],
//             },
//             {
//               sub_grp:
//                 "Set-off of deferred tax liabilities pursuant to set-off provisions",
//               disclosures: [],
//             },
//           ],
//         },
//         {
//           notes_grp: "Contract assets",
//           notes_no: "6A",
//           disclosures: false,
//           sub_grp: [
//             {
//               sub_grp: "Contract assets related to IT consulting contracts",
//               disclosures: [],
//             },
//             { sub_grp: "Loss allowance", disclosures: [] },
//           ],
//         },
//         {
//           notes_grp: "Other non-current Assets",
//           notes_no: "8",
//           disclosures: false,
//           sub_grp: [
//             { sub_grp: "Capital Advances", disclosures: [] },
//             {
//               sub_grp:
//                 "Assets recognized from costs incurred to fulfil a contract",
//               disclosures: [],
//             },
//             {
//               sub_grp: "Advances other than capital advances",
//               disclosures: [],
//             },
//             { sub_grp: "Advances to suppliers", disclosures: [] },
//             { sub_grp: "VAT/GST recoverable", disclosures: [] },
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Current Assets",
//       notes_grp: [
//         {
//           notes_grp: "Financial Assets - Investments",
//           notes_no: "6(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Investments in equity instruments - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in equity instruments - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in equity instruments - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in debentures and bonds - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in debentures and bonds - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },

//             {
//               sub_grp: "Investments in mutual funds - quoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - unquoted",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Investments in mutual funds - impairment",
//               disclosures: [
//                 "Company Name",
//                 "Equity Shares - Current Year",
//                 "Equity Shares - Previous Year",
//                 "Amount - Current Year",
//                 "Amount - Previous Year",
//               ],
//             },
//           ],
//         },
//         //change
//         {
//           notes_grp: "Financial Assets - Trade Receivables",
//           notes_no: "6(b)",
//           disclosures: true,
//           sub_grp: [
//             "Trade Receivables",
//             "Receivables from related parties",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Trade Receivables Considered Good - Secured",
//             "Trade Receivables Considered Good - Unsecured",
//             "Trade Receivables which have significant increase in credit risk",
//             "Trade Receivables - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Cash and cash equivalents",
//           notes_no: "6(d)",
//           disclosures: false,
//           sub_grp: [
//             "Balances with banks in current accounts",
//             "Balances with banks in EEFC accounts",
//             "Deposits with maturity of less than 3 months",
//             "Cash on hand",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Other Financial Assets",
//           notes_no: "6(e)",
//           disclosures: false,
//           sub_grp: [
//             "Derivatives - Foreign Exchange forward contracts",
//             "Derivatives - Foreign currency options",
//             "Derivatives - Interest rate swaps",
//             "Others - Indemnification Asset",
//           ],
//         },
//         {
//           notes_grp: "Financial Assets - Loans",
//           notes_no: "6(c)",
//           disclosures: true,
//           sub_grp: [
//             "Loan to Associates",
//             "Loan to Directors",
//             "Loan to Employees",
//             "Security Deposits",
//             "Loss Allowance",
//           ],
//           disclosures: [
//             "Loans Considered Good - Secured",
//             "Loans Considered Good - Unsecured",
//             "Loans which have significant increase in credit risk",
//             "Loans - Credit Impaired",
//             "Loss Allowance",
//           ],
//         },
//         //change Above
//         {
//           notes_grp: "Contract assets",
//           notes_no: "6A",
//           disclosures: false,
//           sub_grp: [
//             {
//               sub_grp: "Contract assets related to IT consulting contracts",
//               disclosures: [],
//             },
//             { sub_grp: "Loss allowance", disclosures: [] },
//           ],
//         },
//         {
//           notes_grp: "Other current assets",
//           notes_no: "10",
//           disclosures: false,
//           sub_grp: [
//             { sub_grp: "Prepayments", disclosures: [] },
//             { sub_grp: "Right to recover returned goods", disclosures: [] },
//           ],
//         },
//         {
//           notes_grp: "Assets classified as held for sale",
//           notes_no: "11",
//           disclosures: false,
//           sub_grp: [
//             { sub_grp: "Building", disclosures: [] },
//             { sub_grp: "Disposal Group", disclosures: [] },
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Shareholder Funds",
//       notes_grp: [
//         {
//           notes_grp: "Equity Share Capital",
//           notes_no: "12(a)",
//           disclosures: false,
//           sub_grp: [],
//         },
//         {
//           notes_grp:
//             "other equity - equity component of compound financial instruments",
//           notes_no: "13(a)",
//           disclosures: false,
//           sub_grp: [],
//         },
//         {
//           notes_grp: "other equity - reserves and surplus",
//           notes_no: "12(b)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Securities premium",
//               disclosures: [
//                 "Opening balance",
//                 "Exercise of options - proceeds received",
//                 "Acquisition of subsidiary",
//                 "Rights issue",
//                 "Transaction costs arising on share issues",
//               ],
//             },
//             {
//               sub_grp: "Debenture redemption reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Appropriations during the year",
//               ],
//             },
//             {
//               sub_grp: "Share options outstanding account",
//               disclosures: ["Opening balance", "Employee stock option expense"],
//             },
//             {
//               sub_grp: "Retained earnings",
//               disclosures: [
//                 "Opening balance",
//                 "Change in accounting policy",
//                 "Net profit for the period",
//                 "Items of other comprehensive income recognised directly in retained earnings - transfer to debenture redemption reserve",
//                 "Items of other comprehensive income recognised directly in retained earnings - Transactions with NCI",
//                 "Items of other comprehensive income recognised directly in retained earnings - Transfer to retained earnings of FVOCI equity investments",
//                 "Items of other comprehensive income recognised directly in retained earnings - Share of OCI of associates & joint ventures",
//                 "Items of other comprehensive income recognised directly in retained earnings - Remeasurements of post-employment benefit obligation",
//                 "Dividends",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "other equity - other reserves",
//           notes_no: "12(c)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "FVOCI equity investments",
//               disclosures: [
//                 "Opening balance",
//                 "Change in fair value of FVOCI equity investments",
//                 "Deferred tax",
//                 "Transfer of gain on FVOCI equity investments",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Cash flow hedging reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
//                 "Deferred tax",
//                 "Change in fair value of hedging instruments",
//                 "Deferred tax",
//                 "Reclassification to profit / loss",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Costs of hedging reserve",
//               disclosures: [
//                 "Opening balance",
//                 "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
//                 "Deferred tax",
//                 "Change in fair value of hedging instruments",
//                 "Deferred tax",
//                 "Reclassification to profit / loss",
//                 "Deferred tax",
//               ],
//             },
//             {
//               sub_grp: "Foreign currency translation reserve",
//               disclosures: [
//                 "Currency translation adjustments relating to associates",
//                 "Deferred tax",
//                 "Other currency translation differences",
//                 "Non controlling interest share in translation differences",
//                 "Net investment hedge",
//                 "Reclassification to profit / loss on disposal of discontinued operation",
//               ],
//             },
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Non Current Liabilities",
//       notes_grp: [
//         {
//           notes_grp: "Financial Liabilities - Borrowings",
//           notes_no: "13(a)",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Secured debentures",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Secured term loans from banks",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp:
//                 "Secured long term maturities of finance lease obligations",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Unsecured term loans",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             {
//               sub_grp: "Unsecured bonds",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//             //Change
//             {
//               sub_grp:
//                 "Unsecured liability component of compound financial instruments",
//               disclosures: [
//                 "Borrowings",
//                 "Maturity Date",
//                 "Terms of repayment",
//                 "Coupon / interest rate",
//                 "Current Year",
//                 "Previous Year",
//               ],
//             },
//           ],
//           disclosures: [
//             "Less: Current maturities of long term debt",
//             "Less: Current maturities of finance lease obligations",
//             "Less: Interest accrued",
//           ],
//         },
//         //Change Above
//         {
//           notes_grp: "Financial liabilities - Other Financial Liabilities",
//           notes_no: "13(b)",
//           disclosures: false,
//           sub_grp: [
//             {
//               sub_grp: "derivatives not designated as hedges - principal swap",
//               disclosures: [],
//             },
//             { sub_grp: "Others - contingent consideration" },
//           ],
//         },
//         {
//           notes_grp: "Provisions",
//           notes_no: "14",
//           disclosures: true,
//           sub_grp: [
//             {
//               sub_grp: "Service warranties",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp: "Legal claim",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp: "Restructuring costs",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//             {
//               sub_grp:
//                 "Contingent liability recognized on business combination",
//               disclosures: [
//                 "Acquired through business combination",
//                 "Charged/credited to profit or loss - additional provisions recognised",
//                 "charged / credited to profit or loss - unused amounts reversed",
//                 "charged / credited to profit or loss - unwinding of discount",
//                 "Amounts used during the year",
//               ],
//             },
//           ],
//         },
//         {
//           notes_grp: "Employee benefit obligations",
//           notes_no: "15",
//           disclosures: false,
//           sub_grp: [
//             "Leave obligations",
//             "Gratuity",
//             "Post employment medical benefits",
//             "Defined pension benefits",
//             "Share-appreciation rights",
//           ],
//         },
//         {
//           notes_grp: "Deferred tax liabilities",
//           notes_no: "16",
//           disclosures: true,
//           sub_grp: [{ sub_grp: "given in pdf", disclosures: [] }],
//         },
//         {
//           notes_grp: "Government grants",
//           notes_no: "18",
//           disclosures: true,
//           disclosures: [
//             "Opening balance",
//             "Grants during the year",
//             "Less: released to profit or loss",
//           ],
//         },
//       ],
//     },
//     {
//       fs_grp: "Current Liabilities",
//       notes_grp: [],
//     },
//   ],
// };

export const groupings = {
  grp: [
    {
      fs_grp: "Non Current Assets",
      notes_grp: [
        {
          notes_grp: "Property, Plant & Equipment",
          notes_no: "3",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Freehold Land - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Transfers",
                "Assets classified as held for sale",
              ],
            },
            {
              sub_grp: "Freehold Land - Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },

            {
              sub_grp: "Freehold Buildings - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Assets classified as held for sale",
                "Transfers",
              ],
            },
            {
              sub_grp: "Freehold Buildings - Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },

            {
              sub_grp:
                "Furniture, Fittings & Equipment - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Assets classified as held for sale",
                "Transfers"
              ],
            },
            {
              sub_grp:
                "Furniture, Fittings & Equipment - Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },

            {
              sub_grp: "Plant & Machinery - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Assets classified as held for sale",
                "Transfers",
              ],
            },
            {
              sub_grp: "Plant & Machinery - Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },

            {
              sub_grp: "Total - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Assets classified as held for sale",
                "Transfers",
              ],
            },
            {
              sub_grp: "Total - Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },
          ],
        },
        {
          notes_grp: "Capital Work-In Progress",
          notes_no: "3",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                "Exchange Differences",
                "Additions",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Acquisition of subsidiary",
                "Assets classified as held for sale",
                "Transfers",
              ],
            },
            {
              sub_grp: "Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation charge during the year",
                "Exchange Differences",
                "Assets included in a disposal group classified as held for sale",
                "Disposals",
                "Impairment Loss (iii)",
                "Assets classified as held for sale",
              ],
            },
          ],
        },
        {
          notes_grp: "Investment Properties",
          notes_no: "4",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount", 
                "Additions"],
            },
            {
              sub_grp: "Closing Accumulated Depreciation",
              disclosures: [
                "Opening Accumulated Depreciation",
                "Depreciation Charge",
              ],
            },
          ],
        },
        {
          notes_grp: "Other Intangible Assets",
          notes_no: "5",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:
                "Patents, Copyrights and other rights - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount", 
                "Additions",
                "Additions - internal development",
                "Acquisition of subsidiary",],
            },
            {
              sub_grp:
                "Patents, Copyrights and other rights - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },

            {
              sub_grp: "Computer Software - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount",
                 "Additions",
                 "Additions - internal development",
                 "Acquisition of subsidiary",],
            },
            {
              sub_grp: "Computer Software - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },

            {
              sub_grp: "Non-Compete Fees - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount", 
                "Additions",
                "Additions - internal development",
                "Acquisition of subsidiary",],
            },
            {
              sub_grp: "Non-Compete Fees - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },

            {
              sub_grp:
                "Intangible Assets Under Development - Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount", 
                "Additions","Additions - internal development","Acquisition of subsidiary",],
            },
            {
              sub_grp:
                "Intangible Assets Under Development - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },

            {
              sub_grp:
                "Biological Assets other than Bearer Plants - Closing Gross Carrying Amount",
              disclosures: ["Opening Gross Carrying Amount", "Additions","Additions - internal development","Acquisition of subsidiary",],
            },
            {
              sub_grp:
                "Biological Assets other than Bearer Plants - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },

            {
              sub_grp:
                "Total - Closing Gross Carrying Amount",
              disclosures: ["Opening Gross Carrying Amount", "Additions","Additions - internal development","Acquisition of subsidiary",],
            },
            {
              sub_grp:
                "Total - Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization charge for the year",
                "Impairment Charge",
              ],
            },
          ],
        },
        {
          notes_grp: "Goodwill",
          notes_no: "5",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Closing Gross Carrying Amount",
              disclosures: [
                "Opening Gross Carrying Amount", 
                "Additions","Additions - internal development",
                "Acquisition of subsidiary",],
            },
            {
              sub_grp: "Closing Accumulated Amortization",
              disclosures: [
                "Opening Accumulated Amortization",
                "Amortization Charge For The Year",
                "Impairment Charge",
              ],
            },
          ],
        },
        {
          notes_grp: "Financial Assets - Investments",
          notes_no: "6(a)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Investment in equity instruments - Quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Equity Investments at FVOCI - Unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investment in equity instruments - Impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in preference shares - Unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in preference shares - Quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in preference shares - Impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },

            {
              sub_grp: "Investments in government securities - Quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in government securities - Unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in government securities - Impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in debentures and bonds - Quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in debentures and bonds - Unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in debentures and bonds - Impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },

            {
              sub_grp: "Investments in mutual funds - Unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in mutual funds - Quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in mutual funds - Impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",  
                "Amount - Previous Year",
              ],
            },
          ],
        },
        {
          notes_grp: "Financial Assets - Trade Receivables",
          // fs_grp: 'current',
          notes_no: "6(b)",
          disclosures: true,
          sub_grp: [
            {sub_grp:"Trade Receivables",
            disclosures: [
              "Trade Receivables Considered Good - Secured",
              "Trade Receivables Considered Good - Unsecured",
              "Trade Receivables which have significant increase in credit risk",
              "Trade Receivables - Credit Impaired",
              "Loss Allowance",
            ]},
            {sub_grp:"Receivables from related parties",
            disclosures: [
              "Trade Receivables Considered Good - Secured",
              "Trade Receivables Considered Good - Unsecured",
              "Trade Receivables which have significant increase in credit risk",
              "Trade Receivables - Credit Impaired",
              "Loss Allowance",
            ]},
            {sub_grp:"Loss Allowance",
            disclosures: [
              "Trade Receivables Considered Good - Secured",
              "Trade Receivables Considered Good - Unsecured",
              "Trade Receivables which have significant increase in credit risk",
              "Trade Receivables - Credit Impaired",
              "Loss Allowance",
            ]},
          ],
        },
        {
          notes_grp: "Financial Assets - Loans",
          notes_no: "6(c)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Loan to Associates",
              disclosures: [
                "Loans Considered Good - Secured",
                "Loans Considered Good - Unsecured",
                "Loans which have significant increase in credit risk",
                "Loans - Credit Impaired",
                "Loss Allowance",
              ],
            },
            {
              sub_grp:  "Loan to Directors",
              disclosures: [
                "Loans Considered Good - Secured",
                "Loans Considered Good - Unsecured",
                "Loans which have significant increase in credit risk",
                "Loans - Credit Impaired",
                "Loss Allowance",
              ],
            },
            {
              sub_grp:  "Loan to Employees",
              disclosures: [
                "Loans Considered Good - Secured",
                "Loans Considered Good - Unsecured",
                "Loans which have significant increase in credit risk",
                "Loans - Credit Impaired",
                "Loss Allowance",
              ],
            },
            {
              sub_grp:  "Security Deposits",
              disclosures: [
                "Loans Considered Good - Secured",
                "Loans Considered Good - Unsecured",
                "Loans which have significant increase in credit risk",
                "Loans - Credit Impaired",
                "Loss Allowance",
              ],
            },
            {
              sub_grp:  "Loss Allowance",
              disclosures: [
                "Loans Considered Good - Secured",
                "Loans Considered Good - Unsecured",
                "Loans which have significant increase in credit risk",
                "Loans - Credit Impaired",
                "Loss Allowance",
              ],
            },
            // "Loan to Associates",
            // "Loan to Directors",
            // "Loan to Employees",
            // "Security Deposits",
            // "Loss Allowance",
          ]
        },
        {
          notes_grp: "Financial Assets - Other Financial Assets",
          notes_no: "6(e)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Derivatives - Foreign Exchange forward contracts",
              disclosures: [],
            },
            {
              sub_grp: "Derivatives - Foreign currency options",
              disclosures: [],
            },
            { sub_grp: "Derivatives - Interest rate swaps",
disclosures: [] },
            { sub_grp: "Others - Indemnification Asset", disclosures: [] },
          ],
        },
        {
          notes_grp: "Deferred Tax Assets",
          notes_no: "7",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Tax Losses",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary",
              ],
            },
            {
              sub_grp: "Defined benefit obligation",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary",
              ],
            },
            {
              sub_grp: "Provisions",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary",
              ],
            },
            {
              sub_grp: "Other Items - derivatives",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary",
              ],
            },
            {
              sub_grp:
                "Other Items - loss allowance on financial and contract assets",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary",
              ],
            },
            {
              sub_grp: "Other Items - others",
              disclosures: [
                "Charged / credited to profit or loss",
                "Charged / credited to other comprehensive income",
                "Charged / credited to deferred tax on basis adjustment",
                "Acquisition of subsidiary"
                ,
              ],
            },
            {
              sub_grp:
                "Set-off of deferred tax liabilities pursuant to set-off provisions",
              disclosures: [],
            },
          ],
        },
        {
          notes_grp: "Contract assets",
          notes_no: "6A",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Contract assets related to IT consulting contracts",
              disclosures: [],
            },
            { sub_grp: "Loss allowance", disclosures: [] },
          ],
        },
        {
          notes_grp: "Other non-current Assets",
          notes_no: "8",
          disclosures: false,
          sub_grp: [
            { sub_grp: "Capital Advances", 
              disclosures: [] },
            {
              sub_grp:
                "Assets recognized from costs incurred to fulfil a contract",
              disclosures: [],
            },
            {
              sub_grp: "Advances other than capital advances",
              disclosures: [],
            },
            { sub_grp: "Advances to suppliers", 
              disclosures: [] },
            { sub_grp: "VAT/GST recoverable", 
              disclosures: [] },
          ],
        },
        
      ],
    },
    {
      fs_grp: "Current Assets",
      notes_grp: [
        {
          notes_grp: "Financial Assets - Investments",
          notes_no: "6(a)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Investments in equity instruments - quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in equity instruments - unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in equity instruments - impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },

            {
              sub_grp: "Investments in debentures and bonds - quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in debentures and bonds - unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in debentures and bonds - impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },

            {
              sub_grp: "Investments in mutual funds - quoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in mutual funds - unquoted",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
            {
              sub_grp: "Investments in mutual funds - impairment",
              disclosures: [
                "Company Name",
                "Equity Shares - Current Year",
                "Equity Shares - Previous Year",
                "Amount - Current Year",
                "Amount - Previous Year",
              ],
            },
          ],
        },
        {
          notes_grp: "Financial Assets - Trade Receivables",
          notes_no: "6(b)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Trade Receivables",
            },
            {
              sub_grp:  "Receivables from related parties",
            },
            {
              sub_grp:  "Loss Allowance",
            },
          ],
          disclosures: [
            "Trade Receivables Considered Good - Secured",
            "Trade Receivables Considered Good - Unsecured",
            "Trade Receivables which have significant increase in credit risk",
            "Trade Receivables - Credit Impaired",
            "Loss Allowance",
          ],
        },
        {
          notes_grp: "Financial Assets - Cash and cash equivalents",
          notes_no: "6(d)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Balances with banks in current accounts",
            },
            {
              sub_grp:  "Balances with banks in EEFC accounts",
            },
            {
              sub_grp:  "Deposits with maturity of less than 3 months",
            },
            {
              sub_grp:  "Cash on hand",
            },
            
          ],
        },
        {
          notes_grp: "Financial Assets - Other Financial Assets",
          notes_no: "6(e)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Derivatives - Foreign Exchange forward contracts",
            },
            {
              sub_grp:  "Derivatives - Foreign currency options",
            },
            {
              sub_grp:  "Derivatives - Interest rate swaps",
            },
            {
              sub_grp:  "Others - Indemnification Asset",
            }
          ],
        },
        {
          notes_grp: "Financial Assets - Loans",
          notes_no: "6(c)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:   "Loan to Associates",
            },
            {
              sub_grp:  "Loan to Directors",
            },
            {
              sub_grp:   "Loan to Employees",
            },
            {
              sub_grp:    "Security Deposits",
            },
            {
              sub_grp:  "Loss Allowance",
            },
          ],
          disclosures: [
            "Loans Considered Good - Secured",
            "Loans Considered Good - Unsecured",
            "Loans which have significant increase in credit risk",
            "Loans - Credit Impaired",
            "Loss Allowance",
          ],
        },
        {
          notes_grp: "Contract assets",
          notes_no: "6A",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Contract assets related to IT consulting contracts",
              disclosures: [],
            },
            { sub_grp: "Loss allowance", disclosures: [] },
          ],
        },
        {
          notes_grp: "Inventories",
          notes_no: "9",
          disclosures: false,
          sub_grp: [
            { sub_grp: "Raw materials", 
              disclosures: [] },
            {sub_grp:"Work-in-progress",
              disclosures: [],
            },
            {
              sub_grp: "Finished goods",
              disclosures: [],
            },
            { 
              sub_grp: "Traded goods", 
              disclosures: [] },
            { 
              sub_grp: "Stores and spares", 
              disclosures: [] 
            },
          ],
        },
        {
          notes_grp: "Other current assets",
          notes_no: "10",
          disclosures: false,
          sub_grp: [
            { sub_grp: "Prepayments",
              disclosures: [] },
            { sub_grp: "Right to recover returned goods", 
              disclosures: [] },
          ],
        },
        {
          notes_grp: "Assets classified as held for sale",
          notes_no: "11",
          disclosures: false,
          sub_grp: [
            { sub_grp: "Building", disclosures: [] },
            { sub_grp: "Disposal Group", disclosures: [] },
          ],
        },
      ],
    },
    {
      fs_grp: "Shareholder Funds",
      notes_grp: [
        {
          notes_grp: "Equity Share Capital",
          notes_no: "12(a)",
          disclosures: false,
          sub_grp: [
            {sub_grp:  "none",}
            ],
        },
        {
          notes_grp:
            "other equity - equity component of compound financial instruments",
          notes_no: "13(a)",
          disclosures: false,
          sub_grp: [{
            sub_grp:  "none",
          },],
        },
        {
          notes_grp: "other equity - reserves and surplus",
          notes_no: "12(b)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Securities premium",
              disclosures: [
                "Opening balance",
                "Exercise of options - proceeds received",
                "Acquisition of subsidiary",
                "Rights issue",
                "Transaction costs arising on share issues",
              ],
            },
            {
              sub_grp: "Debenture redemption reserve",
              disclosures: [
                "Opening balance",
                "Appropriations during the year",
              ],
            },
            {
              sub_grp: "Share options outstanding account",
              disclosures: [
                "Opening balance",
                "Employee stock option expense"
              ],
            },
            {
              sub_grp: "Retained earnings",
              disclosures: [
                "Opening balance",
                "Change in accounting policy",
                "Net profit for the period",
                "Items of other comprehensive income recognised directly in retained earnings - transfer to debenture redemption reserve",
                "Items of other comprehensive income recognised directly in retained earnings - Transactions with NCI",
                "Items of other comprehensive income recognised directly in retained earnings - Transfer to retained earnings of FVOCI equity investments",
                "Items of other comprehensive income recognised directly in retained earnings - Share of OCI of associates & joint ventures",
                "Items of other comprehensive income recognised directly in retained earnings - Remeasurements of post-employment benefit obligation",
                "Dividends",
              ],
            },
          ],
        },
        {
          notes_grp: "other equity - other reserves",
          notes_no: "12(c)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "FVOCI equity investments",
              disclosures: [
                "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
                "Change in fair value of FVOCI equity investments",
                "Deferred tax",
                "Transfer of gain on FVOCI equity investments",
                "Deferred tax",
              ],
            },
            {
              sub_grp: "Cash flow hedging reserve",
              disclosures: [
                "Opening balance",
                "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
                "Deferred tax",
                "Change in fair value of hedging instruments",
                "Deferred tax",
                "Reclassification to profit / loss",
                "Deferred tax",
              ],
            },
            {
              sub_grp: "Costs of hedging reserve",
              disclosures: [
                "Opening balance",
                "Deferred hedging gains / losses and costs of hedging transferred to the carrying value of inventory purchased in the year",
                "Deferred tax",
                "Change in fair value of hedging instruments",
                "Deferred tax",
                "Reclassification to profit / loss",
                "Deferred tax",
              ],
            },
            {
              sub_grp: "Foreign currency translation reserve",
              disclosures: [
                "Currency translation adjustments relating to associates",
                "Deferred tax",
                "Other currency translation differences",
                "Non controlling interest share in translation differences",
                "Net investment hedge",
                "Reclassification to profit / loss on disposal of discontinued operation",
              ],
            },
            // {
            //   sub_grp: "Total",
            //   disclosures: [
            //     "Currency translation adjustments relating to associates",
            //     "Deferred tax",
            //     "Other currency translation differences",
            //     "Non controlling interest share in translation differences",
            //     "Net investment hedge",
            //     "Reclassification to profit / loss on disposal of discontinued operation",
            //   ],
            // },
          ],
        },
      ],
    },
    {
      fs_grp: "Non Current Liabilities",
      notes_grp: [
        {
          notes_grp: "Financial Liabilities - Borrowings",
          notes_no: "13(a)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Secured debentures",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            {
              sub_grp: "Secured term loans from banks",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            {
              sub_grp:
                "Secured long term maturities of finance lease obligations",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            {
              sub_grp: "Unsecured term loans",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            {
              sub_grp: "Unsecured bonds",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            //Change
            {
              sub_grp:
                "Unsecured liability component of compound financial instruments",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
          ],
          disclosures: [
            "Less: Current maturities of long term debt",
            "Less: Current maturities of finance lease obligations",
            "Less: Interest accrued",
          ],
        },
        {
          notes_grp: "Financial liabilities - Other Financial Liabilities",
          notes_no: "13(b)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "derivatives not designated as hedges - principal swap",
              // disclosures: [],
            },
            { sub_grp: "Others - contingent consideration"},
          ],
        },
        {
          notes_grp: "Financial liabilties - Trade payables",
          notes_no: "13(c)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Trade payables: micro and small enterprises",
            },
            { sub_grp: "Others - contingent consideration"},
            { sub_grp: "Trade payables: others"},
            { sub_grp: "Trade payables to related parties"},
          ],
        },
        {
          notes_grp: "Provisions",
          notes_no: "14",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Service warranties",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp: "Legal claim",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp: "Restructuring costs",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp:
                "Contingent liability recognized on business combination",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
          ],
        },
        {
          notes_grp: "Employee benefit obligations",
          notes_no: "15",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Leave obligations",
            },
            {
              sub_grp:  "Gratuity",
            },
            {
              sub_grp:  "Post employment medical benefits",
            },
            {
              sub_grp:  "Defined pension benefits",
            },
            {
              sub_grp:  "Share-appreciation rights",
            }]
            
        },
        {
          notes_grp: "Deferred tax liabilities",
          notes_no: "16",
          disclosures: true,
          sub_grp: [
            { sub_grp: "Property, plant and equipment amd investment property", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Intangible assets", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Financial assets at fair value through profit or loss", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Other items", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Investments in associates and joint ventures", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Convertible bonds", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Non-current assets recognised for costs to fulfil a contract", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },
            { sub_grp: "Others", 
            disclosures: [
              "Charged/credited to profit or loss - additional provisions recognised",
              "charged / credited to other comprehensive income",
              "charged / credited to transfer from other reserves to retained earnings",
              "charged / credited directly to equity",
              "Acquisition of subsidary",
            ] },

          ],
        },
        {
          notes_grp: "Government grants",
          notes_no: "18",
          // disclosures: true,
          disclosures: [
            "Opening balance",
            "Grants during the year",
            "Less: released to profit or loss",
          ],
          sub_grp: [
            {sub_grp: "Closing balance",}
          ]
        },
      ],
    },
    {
      fs_grp: "Current Liabilities",
      notes_grp: [
        {
          notes_grp: "Financial Liabilities - Borrowings",
          notes_no: "13(a)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Secured loans repayable on demand from banks",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
            {
              sub_grp: "Unsecured loans repayable on demand from related parties",
              disclosures: [
                "Borrowings",
                "Maturity Date",
                "Terms of repayment",
                "Coupon / interest rate",
                "Current Year",
                "Previous Year",
              ],
            },
          ],
          disclosures: [
            "Less: Current maturities of long term debt",
            "Less: Current maturities of finance lease obligations",
            "Less: Interest accrued",
          ],
        },
        {
          notes_grp: "Other Current liabilities",
          notes_no: "19",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Payroll taxes",
            },
            {
              sub_grp: "Statutory tax payables",
            },
            {
              sub_grp: "Refund liabilities",
            },
          ],
        },
        // {
        //   notes_grp: "Other Current liabilities",
        //   notes_no: "19",
        //   disclosures: true,
        //   disclosures: [
        //     "Opening balance",
        //     "Grants during the year",
        //     "Less: released to profit or loss",
        //   ],
        //   sub_grp: [
        //     {
        //       sub_grp: "Payroll taxes",
        //     },
        //     {
        //       sub_grp: "Statutory tax payables",
        //     },
        //     {
        //       sub_grp: "Refund liabilities",
        //     },
        //   ],
        // },
        {
          notes_grp: "Financial liabilities - Other Financial Liabilities",
          notes_no: "13(b)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Current maturities of long term debt",
              // disclosures: [],
            },
            {
              sub_grp: "Current maturities of finance lease obligations",
              // disclosures: [],
            },
            {
              sub_grp: "Interest accrued",
              // disclosures: [],
            },
            {
              sub_grp: "Capital creditors",
              // disclosures: [],
            },
            {
              sub_grp: "Derivatives designated as hedges - Foreign exchange forward contracts",
              // disclosures: [],
            }
          ],
        },
        {
          notes_grp: "Financial liabilties - Trade payables",
          notes_no: "13(c)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp: "Trade payables: micro and small enterprises",
              // disclosures: [],
            },
            { sub_grp: "Others - contingent consideration"},
            { sub_grp: "Trade payables: others"},
            { sub_grp: "Trade payables to related parties"},
          ],
        },
        {
          notes_grp: "Provisions",
          notes_no: "14",
          disclosures: true,
          sub_grp: [
            {
              sub_grp: "Service warranties",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp: "Legal claim",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp: "Restructuring costs",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
            {
              sub_grp:
                "Contingent liability recognized on business combination",
              disclosures: [
                "Acquired through business combination",
                "Charged/credited to profit or loss - additional provisions recognised",
                "charged / credited to profit or loss - unused amounts reversed",
                "charged / credited to profit or loss - unwinding of discount",
                "Amounts used during the year",
              ],
            },
          ],
        },
        {
          notes_grp: "Employee benefit obligations",
          notes_no: "15",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Leave obligations",
            },
            {
              sub_grp:  "Gratuity",
            },
            {
              sub_grp:  "Post employment medical benefits",
            },
            {
              sub_grp:  "Defined pension benefits",
            },
            {
              sub_grp:  "Share-appreciation rights",
            }]
        },
        {
          notes_grp: "Current tax liabilities",
          notes_no: "17",
          disclosures: false,
          sub_grp: [
            {sub_grp: "Closing balance",}
          ],
          disclosures: [
            "Opening balance",
            "Add: current tax payable for the year",
            "Less: taxes paid",
          ]
            
        },
        {
          notes_grp: "Government grants",
          notes_no: "18",
          // disclosures: true,
          disclosures: [
            "Opening balance",
            "Grants during the year",
            "Less: released to profit or loss",
          ],
          sub_grp: [
            {sub_grp: "Closing balance",}
          ]
        },
        // {
        //   notes_grp: "qqqq Liabilities directly associated with assets classified as held for sale",
        //   notes_no: "33",
        //   // disclosures: true,
        //   disclosures: [
        //     "Property , plant and equpiment ",
        //     "Trade Receivables",
        //     "Other current assets",
        //     "Trade payables",
        //     "Other Current liabilities",
        //   ],
        //   sub_grp: [
        //     {sub_grp: "Closing balance",}
        //   ]
        // },

      ],
    },
    {
      fs_grp: "Revenue",
      notes_grp: [
        {
          notes_grp: "Revenue from operations",
          notes_no: "20",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Revenue from contract with customers - Sale of products",
            },
            {
              sub_grp:  "Revenue from contract with customers - Sale of service",
            },
            {
              sub_grp:  "Other Operating Revenue",
            },
            // "Revenue from contract with customers - Sale of products",
            // "Revenue from contract with customers - Sale of service",
            // "Other Operating Revenue",
          ],
        },
        {
          notes_grp: "Other Income",
          notes_no: "21(a)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Rental Income",
            },
            {
              sub_grp:  "Dividend Income from Investments mandatory measure at fair value through profit or loss",
            },
            {
              sub_grp:  "Dividend Income from Equity Investments designed at fair value through other comprehensive income",
            },
            {
              sub_grp:  "Interest Income from financial assets mandatorily measured at fair value through profit or loss",
            },
            {
              sub_grp:  "Interest Income from financial assets at amorised cost",
            },
            {
              sub_grp:  "Unwinding of discount on security deposits",
            },
            {
              sub_grp:  "Government grants",//note 18
            },
            // "Rental Income",
            // "Dividend Income from Investments mandatory measure at fair value through profit or loss",
            // "Dividend Income from Equity Investments designed at fair value through other comprehensive income",
            // "Interest Income from financial assets mandatorily measured at fair value through profit or loss",
            // "Interest Income from financial assets at amorised cost",
            // "Unwinding of discount on security deposits",
            // "Government grants",
          ],
        },
        {
          notes_grp: "Other gains(losses) -net",
          notes_no: "21(b)",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Net gain on disposal of property plants and equipments (Exluding property, plant and equipment sold as part of the discontinued operations)",
            },
            {
              sub_grp:  "Fair Value gains on financial assets mandatorily measured at fair value through profit or loss",
            },
            {
              sub_grp:  "Net Gain on sale of Investments",
            },
            {
              sub_grp:  "Net Fair value losses on derivative nor designed at hedges",
            },
            {
              sub_grp:  "changes in fair value of contingent consideration",
            },
            {
              sub_grp:  "Net foriegn exchange differences",
            },
            {
              sub_grp:  "Other Items",
            },
 
          ],
        },
      ],
    },
    {
      fs_grp: "Expenses",
      notes_grp: [
        {
          notes_grp: "Cost of material consumed",
          notes_no: "22(a)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Raw materials at the begining of the year",
            },
            {
              sub_grp:  "Add:Purchases",
            },
            {
              sub_grp:  "Less:Raw Matrial at the end of the year",
            },
          ],
        },
        {
          notes_grp: "Purchases of stock in-trade",
          notes_no: "",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },
            //No Sub Grouping present here.
          ],
        },
        {
          notes_grp:
          "Changes in inventories of work-in-progress, stock-in-trade and finished goods",
          notes_no: "22(b)",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Opening Balance - Work in progress",
            },
            {
              sub_grp:  "Opening Balance - Finished Goods",
            },
            {
              sub_grp:  "Opening Balance - Traded Goods",
            },
            {
              sub_grp:  "Opening Balance - Right to recover returned Goods",
            },
            {
              sub_grp:  "Total Opening Balance",
            },
            {
              sub_grp:  "Closing Balance - Work in progress",
            },
            {
              sub_grp:  "Closing Balance - Finished Goods",
            },
            {
              sub_grp:  "Closing Balance - Traded Goods",
            },
            {
              sub_grp:  "Closing Balance - Right to recover returned Goods",
            },
            {
              sub_grp:  "Total Closing Balance",
            },
            {
              sub_grp:  "Total changes in inventories of work-in-progress, stock-in-trade and finished goods",
            },
            {
              sub_grp:  "goods",
            },
          ],
        },
        {
          notes_grp: "Excise duty",
          notes_no: "",
          disclosures: false,
          sub_grp: [
            //No Sub Grouping
          ],
        },
        {
          notes_grp: "Employee benefit expense",
          notes_no: "23",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Salary, wages and bonus",
            },
            {
              sub_grp:  "Contribution to Provident fund",
            },
            {
              sub_grp:  "Employee Share - based payment expense",
            },
            {
              sub_grp:  "gratuity",
            },
            {
              sub_grp:  "Leave compensation",
            },
            {
              sub_grp:  "Post employment pension benefits",
            },
            {
              sub_grp:  "Post employment medical benefits",
            },
            {
              sub_grp:  "Staff welfare expenses",
            },
            
            // "Salary, wages and bonus",
            // "Contribution to Provident fund",
            // "Employee Share - based payment expense",
            // "gratuity",
            // "Leave compensation",
            // "Post employment pension benefits",
            // "Post employment medical benefits",
            // "Staff welfare expenses",
          ],
        },
        {
          notes_grp: "Depreciation and Amortisation expense",
          notes_no: "24",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Depreciation of property plant and equipment",
            },
            {
              sub_grp:  "Depreciation on Investment properties",
            },
            {
              sub_grp:  "Amortisation of Intangible assets",
            },
          ],
        },
        {
          notes_grp: "Impairment of goodwill and other non-current assets",
          notes_no: "3,5",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },
            //pending
          ],
        },
        {
          notes_grp: "Net impairment losses on financial and contract assets",
          notes_no: "29",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },
            //Not Sub Grouping Present
          ],
        },
        {
          notes_grp: "Other Expenses",
          notes_no: "25",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Consumption of stores and spare",
            },
            {
              sub_grp:  "Repairs and maintainance plants and machinearies",
            },
            {
              sub_grp:  "Repairs and maintainance buildings",
            },
            {
              sub_grp:  "Repairs and maintainance others",
            },
            {
              sub_grp:  "Telephone and communication charges",
            },
            {
              sub_grp:  "Water and electricity charges",
            },
            {
              sub_grp:  "Rental charges",
            },
            {
              sub_grp:  "Rates and taxes",
            },
            {
              sub_grp:  "Legal and professional fees",
            },
            {
              sub_grp:  "Travel and conveyance",
            },
            {
              sub_grp:  "Insurance",
            },
            {
              sub_grp:  "Printing and stationary",
            },
            {
              sub_grp:  "Sales commsions",
            },
            {
              sub_grp:  "Brokerage and commison",
            },
            {
              sub_grp:  "Provisons - Restructuring Costs",
            },
            {
              sub_grp:  "Provisons - Service Warrenties",
            },
            {
              sub_grp:  "Provisons - Legal claims",
            },
            {
              sub_grp:  "Corporate social resposibility expenditure",
            },
            {
              sub_grp:  "Payment to auditors",
            },
            {
              sub_grp:  "Miscellanious expenses",
            },
            // "Consumption of stores and spare",
            // "Repairs and maintainance plants and machinearies",
            // "Repairs and maintainance buildings",
            // "Repairs and maintainance others",
            // "Telephone and communication charges",
            // "Water and electricity charges",
            // "Rental charges",
            // "Rates and taxes",
            // "Legal and professional fees",
            // "Travel and conveyance",
            // "Insurance",
            // "Printing and stationary",
            // "Sales commsions",
            // "Brokerage and commison",
            // "Provisons - Service Warrenties",
            // "Provisons - Restructuring Costs",
            // "Provisons - Legal claims",
            // "Corporate social resposibility expenditure",
            // "Payment to auditors",
            // "Miscellanious expenses",
          ],
        },
        {
          notes_grp: "Financial Costs",
          notes_no: "26",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Interest and finance charges on financial liabilities not at fair value through profit or loss",
            },
            {
              sub_grp:  "Unwinding of discount on provisions",
            },
            {
              sub_grp:  "Fair value changes on interest rate swaps designted as cash flow hedges-transfer from oci",
            },
            {
              sub_grp:  "Exhange difference regarded as an adjustment to borrowing costs",
            },
            {
              sub_grp:  "Less:Amount Capitalised",// user input
            },
            // "Interest and finance charges on financial liabilities not at fair value through profit or loss",
            // "Unwinding of discount on provisions",
            // "Fair value changes on interest rate swaps designted as cash flow hedges-transfer from oci ",
            // "Exhange difference regarded as an adjustment to borrowing costs",
            // "Less:Amount Capitalised",
          ],
        },
        {
          notes_grp: "Income tax expense",
          notes_no: "27",
          disclosures: true,
          sub_grp: [
            {
              sub_grp:  "Current tax",
            },
            {
              sub_grp:  "Deferred tax",
            }
          ],
        },
      ],
    },
    {
      fs_grp: "Other Comprehensive Income",
      notes_grp: [
        {
          notes_grp: "Gains on cash  flow hedges",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },
            //No sub grouping
          ],
        },
        {
          notes_grp: "Costs of Hedging",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },

          ],
        },
        {
          notes_grp: "Investment properties",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            },
          ],
        },
        {
          notes_grp: "Goodwill",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "Closing gross carrying amount",
            },
            {
              sub_grp:  "Closing accumulated amortization",
            },
            // "Closing gross carrying amount", "Closing accumulated amortization"
          ],
        },
        {
            notes_grp: "Other Intangible Assets",
            notes_no: "12",
            disclosures: false,
            sub_grp: [
              
              {
                sub_grp:  "None",
              }
          ],
        },
        {
          notes_grp: "Intangible Assets under development",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            }
          ],
        },
        {
          notes_grp: "Biological assets other than Bearer Plants",
          notes_no: "12",
          disclosures: false,
          sub_grp: [
            {
              sub_grp:  "None",
            }
          ],
        },
      ],
    },
  ],
};


